import React, { useEffect, useState } from "react";
import axios from "axios";
import "./UserList.css";

const UserList = () => {
  const [users, setUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/users`)
      .then((response) => {
        setUsers(response.data);
        setFilteredUsers(response.data);
      })
      .catch((error) => {
        console.error("There was an error fetching the users!", error);
      });
  }, []);

  const restrictUser = (userId) => {
    axios
      .post(`${process.env.REACT_APP_API_URL}/users/${userId}/restrict`)
      .then((response) => {
        setUsers(
          users.map((user) =>
            user.id === userId ? { ...user, status: "Disabled" } : user
          )
        );
        setFilteredUsers(
          filteredUsers.map((user) =>
            user.id === userId ? { ...user, status: "Disabled" } : user
          )
        );
        alert(response.data.message);
      })
      .catch((error) => {
        console.error("There was an error restricting the user!", error);
        alert("Failed to restrict the user.");
      });
  };

  const unrestrictUser = (userId) => {
    axios
      .post(`${process.env.REACT_APP_API_URL}/users/${userId}/unrestrict`)
      .then((response) => {
        setUsers(
          users.map((user) =>
            user.id === userId ? { ...user, status: "Active" } : user
          )
        );
        setFilteredUsers(
          filteredUsers.map((user) =>
            user.id === userId ? { ...user, status: "Active" } : user
          )
        );
        alert(response.data.message);
      })
      .catch((error) => {
        console.error("There was an error unrestricting the user!", error);
        alert("Failed to unrestrict the user.");
      });
  };

  const toggleAdmin = (userId, currentType) => {
    axios
      .post(`${process.env.REACT_APP_API_URL}/users/${userId}/toggle_admin`)
      .then((response) => {
        setUsers(
          users.map((user) =>
            user.id === userId ? { ...user, type: response.data.type } : user
          )
        );
        setFilteredUsers(
          filteredUsers.map((user) =>
            user.id === userId ? { ...user, type: response.data.type } : user
          )
        );
        alert(response.data.message);
      })
      .catch((error) => {
        console.error("There was an error toggling the admin status!", error);
        alert("Failed to toggle admin status.");
      });
  };

  const handleSearch = (event) => {
    const term = event.target.value.toLowerCase();
    setSearchTerm(term);
    const filtered = users.filter((user) =>
      user.email.toLowerCase().includes(term)
    );
    setFilteredUsers(filtered);
  };

  return (
    <div className="user-list">
      <h2>User List</h2>
      <input
        type="text"
        placeholder="Search by email..."
        value={searchTerm}
        onChange={handleSearch}
        className="search-bar"
      />
      <div className="table-container">
        <table>
          <thead>
            <tr>
              <th>Email</th>
              <th>Name</th>
              <th>DOB</th>
              <th>Phone</th>
              <th>Designation</th>
              <th>Address</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredUsers.map((user) => (
              <tr key={user.id}>
                <td>{user.email}</td>
                <td>
                  {user.firstName} {user.lastName}
                </td>
                <td>{user.dob}</td>
                <td>{user.phone}</td>
                <td>
                  {user.designation}, {user.institution}
                </td>
                <td>
                  {user.city}, {user.country}
                </td>
                <td
                  style={{ color: user.status === "active" ? "green" : "red" }}
                >
                  {user.status}
                </td>
                <td>
                  <div className="dropdown">
                    <button className="dropbtn">Actions</button>
                    <div className="dropdown-content">
                      {user.status === "active" ? (
                        <button onClick={() => restrictUser(user.id)}>
                          Restrict Account
                        </button>
                      ) : (
                        <button onClick={() => unrestrictUser(user.id)}>
                          Unrestrict Account
                        </button>
                      )}
                      {user.type === "admin" ? (
                        <button onClick={() => toggleAdmin(user.id, "admin")}>
                          Remove From Admin
                        </button>
                      ) : (
                        <button onClick={() => toggleAdmin(user.id, "user")}>
                          Make Admin
                        </button>
                      )}
                    </div>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default UserList;
